const durations: Base.DurationButtonModel[] = [
  {
    text: 'From Beginning',
    key: 'FROM_BEGINNING',
    isPicker: false
  },
  {
    text: 'Last Year',
    key: 'FROM_LAST_YEAR',
    isPicker: false
  },
  {
    text: 'Last 6 Months',
    key: 'FROM_LAST_SIX_MONTHS',
    isPicker: false
  },
  {
    text: 'Last Month',
    key: 'FROM_LAST_MONTH',
    isPicker: false
  },
  {
    text: 'Last 2 Weeks',
    key: 'FROM_LAST_TWO_WEEKS',
    isPicker: false
  },
  {
    text: 'Last Week',
    key: 'FROM_LAST_WEEK',
    isPicker: false
  },
  {
    text: 'Today',
    key: 'TODAY',
    isPicker: false
  },
  {
    text: 'Monthly',
    key: 'MONTHLY',
    isPicker: true
  },
  {
    text: 'Yearly',
    key: 'YEARLY',
    isPicker: true
  },
  {
    text: 'Custom Date',
    key: 'CUSTOM_DATE',
    isPicker: true
  }
];

export default durations;
